/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Unchanged_HintInputs */

const cs_ebr_unchanged_hint = /** @type {(inputs: Ebr_Unchanged_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data ve feedu odpovídají CRM.`)
};

const en_ebr_unchanged_hint = /** @type {(inputs: Ebr_Unchanged_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feed data matches CRM.`)
};

/**
* | output |
* | --- |
* | "Feed data matches CRM." |
*
* @param {Ebr_Unchanged_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_unchanged_hint = /** @type {((inputs?: Ebr_Unchanged_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Unchanged_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_unchanged_hint(inputs)
	return cs_ebr_unchanged_hint(inputs)
});